export default __webpack_public_path__ + "static/media/beJOE.01e97e94.svg";